module.exports = __webpack_public_path__ + "static/media/plantPal2_01.8562cfbc.gif";